import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class FsLabelComponent {
    constructor() {
    }
}
FsLabelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsLabelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsLabelComponent, selector: "fs-label", ngImport: i0, template: "<ng-content></ng-content>", styles: [":host{transform-origin:0 0;transition:none;display:flex;color:#0000008a;font-size:75%;transform:translateY(-.125em) perspective(100px);min-height:12px}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLabelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-label',
                    templateUrl: 'label.component.html',
                    styleUrls: ['label.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return []; } });

class FsLabelFieldComponent {
    constructor() {
        this.bottomMargin = true;
        this.topMargin = true;
        this.labelMargin = true;
    }
    set setBottomMargin(value) {
        this.bottomMargin = value;
    }
    set setTopMargin(value) {
        this.topMargin = value;
    }
    set setLabelMargin(value) {
        this.labelMargin = value;
    }
}
FsLabelFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLabelFieldComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsLabelFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsLabelFieldComponent, selector: "fs-label-field", inputs: { setBottomMargin: ["bottomMargin", "setBottomMargin"], setTopMargin: ["topMargin", "setTopMargin"], setLabelMargin: ["labelMargin", "setLabelMargin"] }, host: { properties: { "class.field-bottom-margin": "this.bottomMargin", "class.field-top-margin": "this.topMargin", "class.field-label-margin": "this.labelMargin" } }, ngImport: i0, template: "<div class=\"field-wrap\">\n  <div class=\"field-label\"><ng-content select=\"fs-label\"></ng-content></div>\n\n  <div class=\"field-content\">\n    <ng-content></ng-content>\n  </div>\n</div>\n\n<div class=\"field-message\">\n  <ng-content select=\"fs-label-message\"></ng-content>\n</div>\n", styles: [":host{display:block;position:relative}:host.field-label-margin .field-label{min-height:16px}:host.field-bottom-margin .field-message{min-height:14px;margin-top:5px}.field-label:empty{display:none}.field-message{font-size:75%;color:#0000008a}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLabelFieldComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-label-field',
                    templateUrl: 'label-field.component.html',
                    styleUrls: ['label-field.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { setBottomMargin: [{
                type: Input,
                args: ['bottomMargin']
            }], setTopMargin: [{
                type: Input,
                args: ['topMargin']
            }], setLabelMargin: [{
                type: Input,
                args: ['labelMargin']
            }], bottomMargin: [{
                type: HostBinding,
                args: ['class.field-bottom-margin']
            }], topMargin: [{
                type: HostBinding,
                args: ['class.field-top-margin']
            }], labelMargin: [{
                type: HostBinding,
                args: ['class.field-label-margin']
            }] } });

class FsLabelMessageComponent {
    constructor() {
    }
}
FsLabelMessageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLabelMessageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsLabelMessageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsLabelMessageComponent, selector: "fs-label-message", ngImport: i0, template: "<ng-content></ng-content>", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLabelMessageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-label-message',
                    templateUrl: 'label-message.component.html',
                    styleUrls: ['label-message.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return []; } });

class FsLabelModule {
}
FsLabelModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLabelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsLabelModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLabelModule, declarations: [FsLabelComponent,
        FsLabelFieldComponent,
        FsLabelMessageComponent], imports: [CommonModule], exports: [FsLabelComponent,
        FsLabelFieldComponent,
        FsLabelMessageComponent] });
FsLabelModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLabelModule, imports: [[
            CommonModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLabelModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                    ],
                    exports: [
                        FsLabelComponent,
                        FsLabelFieldComponent,
                        FsLabelMessageComponent
                    ],
                    entryComponents: [],
                    declarations: [
                        FsLabelComponent,
                        FsLabelFieldComponent,
                        FsLabelMessageComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FsLabelComponent, FsLabelFieldComponent, FsLabelMessageComponent, FsLabelModule };
